import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from '../../elements/Navbar';
import Footer from '../../elements/Footer';
import HomePage from '../../pages/HomePage';
import ExplorePage from '../../pages/ExplorePage';
import MonitorPage from '../../pages/MonitorPage/MonitorPage';
import NewsPage from '../../pages/NewsPage/NewsPage';
import NewsDetailPage from '../../pages/NewsDetailPage/NewsDetailPage';
import AboutPage from '../../pages/AboutPage/AboutPage';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppContainer: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-white">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/explore" element={<ExplorePage />} />
          <Route path="/monitor" element={<MonitorPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:id" element={<NewsDetailPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/campsite/:id" element={<></>} />
          <Route path="/map" element={<></>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default AppContainer;

